import React, { useContext } from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import i18nInstance from '../../i18n/i18nInstance'
import Button, { ButtonProps } from '../Button'
import { IconCloseDefault } from '../Icons'
import { ModalContext } from '../Modal'

const ModalClose = ({ className = '', ...props }: ButtonProps) => {
  const { close } = useContext(ModalContext)
  const { t } = useTranslation('@mc/design-system')

  return (
    <Button
      {...props}
      className={`mc-modal__close mc-p-0 ${className}`}
      data-testid='modal-close-button'
      kind='link'
      onClick={close('close')}
    >
      <IconCloseDefault
        className='mc-icon--scale-4 mc-m-2'
        srText={t('modal.closeButtonAlt')}
      />
    </Button>
  )
}

export default withI18nContext(i18nInstance)(ModalClose)
